// Zajednički stil stranice za štampu (react-to-print). Podrazumevani pageStyle
// biblioteke postavlja marginu 0.
// Veličina i orijentacija lista se namerno ne zadaju (@page size): kada ih
// stranica zada, Chrome u dijalogu za štampu ne nudi izbor Portrait/Landscape.
// Papir i orijentaciju bira korisnik; sadržaj se prilagođava širini lista.
// Registar rizika ima sopstveni prikaz za štampu i ne koristi ovaj stil.
export const PRINT_PAGE_STYLE = `
  @page { margin: 12mm; }
  @media print {
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    /* sadržaj za štampu zauzima punu širinu lista (na ekranu ostaje kako jeste) */
    .poslovni-procesi-tables {
      width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
`;
